import { render, staticRenderFns } from "./PackagePayment.vue?vue&type=template&id=7869b655&"
import script from "./PackagePayment.vue?vue&type=script&lang=js&"
export * from "./PackagePayment.vue?vue&type=script&lang=js&"
import style0 from "./PackagePayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackagePayment.vue"
export default component.exports